import axiosInstance from 'src/services/common/axiosInstance'
import { API_ROUTES } from 'src/services/common/routes'

const putUpRank = async (userId, userRank) => {
  if (!userId || !userRank) return false

  const nextRank = userRank === 'bronze' ? 1 : 2

  try {
    const res = await axiosInstance.put(API_ROUTES.UpRank.replace(':id', userId), {
      ranking: nextRank
    })

    if (res.data.success === false) return false
    return true
  } catch (error) {
    return false
  }
}

export default putUpRank
